import { IDataTableOptionalProps } from "../components/DataTable/common/defaults";

export const defaultDTOptions:IDataTableOptionalProps = {
    showSelectInfo: false,
    lengthChange:false,
    order:[[1,'asc']],
    select:false,
    dom:'tp'
}

interface IStringTMap<T> {
    [key: string]: T;
}

export interface IStringNumberMap extends IStringTMap<number> {}